import { FormControlLabel, FormControlLabelProps, Radio, styled } from "@mui/material";
import type { JSX } from "react";

interface RadioFieldProps extends Omit<FormControlLabelProps, "control"> {
  selected: boolean;
}

type StyledRadioFieldProps = {
  selectedState: boolean;
};

const StyledFormControlLabel = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== "selectedState",
})<StyledRadioFieldProps>(({ theme, selectedState }) => ({
  ...((theme.components?.RadioField?.styleOverrides?.root?.({
    ownerState: { selected: selectedState },
    theme,
  }) as object) || {}),
}));

export const RadioField = ({ selected, value, label, ...props }: RadioFieldProps): JSX.Element => {
  return (
    <StyledFormControlLabel
      selectedState={selected}
      control={<Radio sx={{ p: 0 }} />}
      label={label}
      value={value}
      {...props}
    />
  );
};
